import React, { Component } from 'react';
import { push } from 'connected-react-router';
import clsx from 'clsx';
import lodash from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import {
  Typography,
  SvgIcon,
  Button,
  Divider,
  List,
  ListItem,
  withWidth
} from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import { Helmet } from 'react-helmet';

import Moment from 'react-moment';
import LoadingGif from '../../images/Loading.gif';
import { ReactComponent as ShareIcon } from '../../images/Icons/share.svg';
import { ReactComponent as EditIcon } from '../../images/Icons/edit.svg';

import Shop from '../shop/Shop';
import Favourites from './Favourites';
import Followers from './Followers';
import Followings from './Followings';
import AboutMe from './AboutMe';

import {
  fetchUser,
  fetchPublicStats,
  fetchPrivateStats
} from '../../redux/actions/user';
import { updateMedia } from '../../redux/actions/auth';

import {
  UPDATE_USER_SUCCESSFULL,
  USER_PUBLIC_STATS_REQUESTED,
  USER_PUBLIC_STATS_RETRIEVED,
  USER_PUBLIC_STATS_FAILED,
  USER_REQUESTED,
  USER_RETRIEVED,
  USER_FAILED,
  ACTIVATE_HOLIDAY_MODE_SUCCESSFULL,
  DEACTIVATE_HOLIDAY_MODE_SUCCESSFULL,
  UPDATE_USER_MEDIA_SUCCESSFULL,
  UPDATE_USER_MEDIA_ERRORED,
  UPDATE_USER_MEDIA_REQUESTED,
  USER_PRIVATE_STATS_RETRIEVED
} from '../../redux/actions/types';
import { ReactComponent as InfoIcon } from '../../images/Icons/info.svg';
import RTVAvatar from '../../commons/RTVAvatar';
import RTVMenu from '../../commons/RTVMenu';
import RTVFollowButton from '../../commons/RTVFollowButton';
import RTVRating from '../../commons/RTVRating';
import DresserShareMenu from '../../commons/menus/ShareToSocialMenu';
import MailShareDialog from '../../commons/dialogs/RTVMailShareDialog';
import RTVHolidayMode from '../../commons/RTVHolidayMode';
import RTVDialogButton from '../../commons/RTVDialogButton';
import RTVDisable from '../../commons/RTVDisable';
import ImageEditorDialog from '../../commons/ImageEditorDialog';
import RTVDialog from '../../commons/dialogs/RTVDialog';
import RoleIcon from '../../commons/RoleIcon';
import abbreviateNumbers from '../../utils/abbreviateNumbers';
import i18next from 'i18next';

const translatePromotion = promotion => {
  switch (promotion) {
    case 'TWO_FOR_ONE':
      return '2x1';
    case 'THREE_FOR_TWO':
      return '3x2';
    case 'TWENTY_PERCENT':
      return '20% Extra';
    case 'THIRTY_PERCENT':
      return '30% Extra';
    case 'FORTY_PERCENT':
      return '40% Extra';
    case 'FREE_SHIPPING':
      return 'Envío Gratis';
    case 'FIXED_SHIPPING':
      return 'Envío a $' + promotion.type_parameter;
    default:
      return promotion;
  }
};

const styles = theme => ({
  loadingView: {
    width: '100%',
    height: '100vh',
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  dresser: {
    minHeight: '100vh'
  },
  userInfoHeader: {
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'flex-start',
    justifyContent: 'space-evenly',
    '& > *': {
      margin: theme.spacing(0.5, 0.5, 1, 0.5)
    }
  },
  dresserHeader: {
    padding: theme.spacing(3),
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(3, 0, 3, 0)
    }
  },
  dresserHeaderLeft: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dresserHeaderRight: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    '& > *': {
      marginRight: theme.spacing(1)
    },
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'center'
    }
  },
  shareButton: {
    minWidth: 'unset',
    width: '36px'
  },
  shareIcon: {
    '& > path': {
      stroke: '#fff'
    }
  },
  ratingSection: {
    display: 'flex',
    alignItems: 'flex-end',
    justifyContent: 'center',
    [theme.breakpoints.down('sm')]: {
      flexFlow: 'column',
      alignItems: 'flex-start',
      '& > p': {
        marginLeft: 0
      }
    }
  },
  ratingText: {
    fontSize: '0.8rem',
    display: 'flex',
    alignItems: 'center',
    marginLeft: theme.spacing(1),
    '&:hover': {
      cursor: 'pointer',
      textDecoration: 'underline'
    }
  },
  dresserNav: {
    padding: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    boxShadow: '0 10px 10px 0 rgba(0, 0, 0, 0.04)',
    borderBottomLeftRadius: theme.shape.borderRadius,
    borderBottomRightRadius: theme.shape.borderRadius,
    '& > hr': {
      height: 'auto',
      alignSelf: 'stretch'
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(0.5),
      width: 'unset'
    }
  },
  selector: {
    cursor: 'pointer',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    padding: theme.spacing(0, 4, 0, 4),
    '& > *': {
      textAlign: 'center'
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1),
      margin: 0,
      '& p:nth-child(1)': {
        fontSize: '1.3rem !important'
      },
      '& p:nth-child(2)': {
        fontSize: '0.9rem !important'
      }
    }
  },
  selected: {
    color: theme.palette.primary.main,
    '& p:nth-child(2)': {
      textDecoration: 'underline'
    },
    '& > *': {
      color: theme.palette.primary.main
    }
  },
  moreOptionsMenu: {
    width: '100%',
    display: 'flex',
    flexFlow: 'column'
  },
  item: {
    cursor: 'pointer',
    color: '#707070'
  },
  notClickable: {
    cursor: 'default'
  },
  actions: {
    width: '100%',
    padding: theme.spacing(2),
    backgroundColor: '#fdfbfc',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  form: {
    flex: 1,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    '& > p': {
      fontWeight: 600,
      marginRight: theme.spacing(2)
    }
  },
  avatarSection: {
    display: 'flex',
    flexFlow: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  editAvatarText: {
    fontWeight: 400,
    fontSize: '0.9rem',
    color: '#fff',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    '& > svg': {
      width: '0.9rem',
      height: '0.9rem'
    }
  },
  promotionSection: {
    display: 'flex',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'sticky',
    top: '80px',
    zIndex: 999,
    [theme.breakpoints.down('sm')]: {
      position: 'inherit'
    }
  },
  promotionMessage: {
    padding: theme.spacing(1, 3, 1, 3),
    position: 'relative',
    backgroundColor: '#F7F5B4',
    borderRadius: theme.shape.borderRadius,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    '& > *': {
      textAlign: 'center'
    }
  },
  infoIcon: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color: theme.palette.primary.main
  }
});

const MoreOptions = ({ classes, user, ...props }) => (
  <div className={classes.moreOptionsMenu}>
    <List>
      <ListItem className={classes.item} onClick={props.share} divider>
        · Compartir
      </ListItem>
      <RTVFollowButton user={user.id}>
        {followProps =>
          followProps.following && (
            <ListItem
              divider
              disabled={followProps.loading}
              onClick={followProps.onClick}
              className={classes.item}
            >
              · Dejar de seguir
            </ListItem>
          )
        }
      </RTVFollowButton>
      <ListItem className={classes.item}>· Reportar</ListItem>
    </List>
  </div>
);

class Dresser extends Component {
  constructor(props) {
    super();
    const { userID } = props.match.params;
    const { username } = props.match.params;

    this.shareRef = React.createRef();
    this.moreRef = React.createRef();

    this.PAGES = {
      PRODUCTS: 'productos',
      FOLLOWERS: 'seguidoras',
      FOLLOWINGS: 'siguiendo',
      FAVOURITES: 'favoritos',
      ABOUT_ME: 'sobre-mi' // O perfil?
    };

    const {
      match: {
        params: { page }
      }
    } = props;

    // If we have a default 'page' selected on the route,
    // check if it actually exists.
    const pageExist = Object.values(this.PAGES).includes(page);
    if (page && !pageExist) {
      props.push('/404');
    }

    this.state = {
      idType: username ? 'username' : 'id',
      userID: username ? username.toLowerCase() : userID,
      user: null,
      userStats: null,
      privateStats: props.privateStats ? props.privateStats : null,
      hasReservedProducts:
        props.privateStats && props.privateStats.COUNTERS_GROUP_PRODUCTS
          ? props.privateStats.COUNTERS_GROUP_PRODUCTS.some(
              group => group.status === 'STATUS_RESERVED'
            )
          : false,

      currentPage: page || this.PAGES.PRODUCTS,

      shareMenu: false,
      moreMenu: false,
      mailDialog: false,
      mailString: '',

      imageSrc: '',
      cropping: false,
      rtvDialogContent: {
        open: false,
        content: {}
      },
      imageLoading: false
    };
  }

  componentDidMount() {
    this.fetchUser();
    if (
      this.props.match.params.page &&
      Object.values(this.PAGES).includes(this.props.match.params.page)
    ) {
      return;
    }
    let path = '/vestidor/id';
    if (this.state.idType === 'username') {
      path = '/vestidor';
    }
    window.history.replaceState(
      window.history.state,
      '',
      `${path}/${this.state.userID}/${this.state.currentPage}`
    );
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.currentPage !== this.state.currentPage) {
      let path = '/vestidor/id';
      if (this.state.idType === 'username') {
        path = '/vestidor';
      }
      window.history.replaceState(
        window.history.state,
        '',
        `${path}/${this.state.userID}/${this.state.currentPage}`
      );
    }

    if (!lodash.isEqual(prevProps.match, this.props.match)) {
      const { userID } = this.props.match.params;
      const { username } = this.props.match.params;
      this.setState(
        {
          idType: username ? 'username' : 'id',
          userID: username ? username.toLowerCase() : userID
        },
        this.fetchUser
      );
    }

    if (prevProps.authStatus !== this.props.authStatus) {
      if (this.props.authStatus === UPDATE_USER_MEDIA_REQUESTED) {
        this.setState({ imageLoading: true });
      }
      if (this.props.authStatus === UPDATE_USER_MEDIA_SUCCESSFULL) {
        this.setState({
          rtvDialogContent: {
            open: true,
            content: {
              title: 'Wohoo',
              message: 'Cambiaste tu foto de perfil exitosamente!',
              onClose: () => window.location.reload()
            }
          },
          cropping: false,
          imageLoading: false
        });
      }
      if (this.props.authStatus === UPDATE_USER_MEDIA_ERRORED) {
        this.setState({
          rtvDialogContent: {
            open: true,
            content: {
              title: 'Uups',
              message:
                'Parece que hubo un error al subir tu nueva foto de perfil :('
            }
          },
          cropping: false,
          imageLoading: false
        });
      }
    }

    if (prevProps.userStatus !== this.props.userStatus) {
      if (
        this.props.userStatus === ACTIVATE_HOLIDAY_MODE_SUCCESSFULL ||
        this.props.userStatus === DEACTIVATE_HOLIDAY_MODE_SUCCESSFULL
      ) {
        this.fetchUser();
      }

      if (this.props.userStatus === UPDATE_USER_SUCCESSFULL) {
        this.setState(state => ({
          ...state,
          user: this.props.users[state.userID]
        }));
      }
      if (
        this.props.userStatus === USER_REQUESTED &&
        this.props.users.requesting === this.state.userID
      ) {
        this.setState({
          user: null,
          userStats: null
        });
      }
      if (
        this.props.userStatus === USER_RETRIEVED &&
        this.props.users.requesting === this.state.userID
      ) {
        this.setState(
          state => ({
            ...state,
            user: this.props.users[state.userID]
          }),
          () => this.props.fetchPublicStats(this.state.user.id)
        );
      }
      if (
        this.props.userStatus === USER_FAILED &&
        this.props.users.requesting === this.state.userID
      ) {
        if (this.props.userError.status === 404) {
          this.props.push('/user-not-found');
        }
      }

      if (
        this.props.userStatus === USER_PUBLIC_STATS_REQUESTED &&
        this.state.user &&
        this.props.publicStats.requesting === this.state.user.id
      ) {
        this.setState({
          userStats: null
        });
      }
      if (
        this.props.userStatus === USER_PUBLIC_STATS_RETRIEVED &&
        this.state.user &&
        this.props.publicStats.requesting === this.state.user.id
      ) {
        this.setState(state => ({
          userStats: this.props.publicStats[state.user.id]
        }));
      }
      if (
        this.props.userStatus === USER_PUBLIC_STATS_FAILED &&
        this.state.user &&
        this.props.publicStats.requesting === this.state.user.id
      ) {
        // Failed to retrieve user's public stats... what to do...
        // TODO(tomas): Handle this pls.
      }
      if (this.props.userStatus === USER_PRIVATE_STATS_RETRIEVED) {
        this.setState(state => ({
          privateStats: this.props.privateStats,
          hasReservedProducts: this.props.privateStats.COUNTERS_GROUP_PRODUCTS.some(
            group => group.status === 'STATUS_RESERVED'
          )
        }));
      }
    }

    if (
      prevState.mailDialog !== this.state.mailDialog &&
      !this.state.mailDialog
    ) {
      this.setState({ mailString: '' });
    }
  }

  changePage = page => {
    this.setState({ currentPage: page });
  };

  fetchUser = () => {
    this.props.fetchUser(this.state.userID, this.state.idType);
  };

  handleOpenShareMenu = () => {
    this.setState({ shareMenu: true });
  };

  handleOpenMoreMenu = () => {
    this.setState({ moreMenu: true });
  };

  openMailDialog = () => {
    this.setState({ mailDialog: true });
  };

  setMailString = mailString => {
    this.setState({ mailString });
  };

  handleMailDialogClose = () => {
    this.setState({ mailDialog: false });
  };

  confirmMailDialog = () => {
    const dresserOwnerText = 'Mirá los productos que subí en mi vestidor!';
    const dresserViewerText = 'Mirá el vestidor que encontré!';

    window.open(
      `mailto:${this.state.mailString}?&body=${
        this.props.loggedInUser.id === this.state.user.id
          ? dresserOwnerText
          : dresserViewerText
      }+${window.encodeURIComponent(
        `${process.env.REACT_APP_WEB_URL}/vestidor/id/${this.state.user.id}`
      )}`,
      '_blank'
    );
    this.handleMailDialogClose();
  };

  handleEditorFinish = result => {
    const MAX_SIZE = 2000000; // 2MB
    if (result.size >= MAX_SIZE) {
      this.setState({
        rtvDialogContent: {
          open: true,
          content: {
            title: 'Uups',
            message: 'Parece que tu foto supera los 2MB de tamaño!'
          }
        }
      });
      return;
    }
    this.props.updateMedia(result);
  };

  handleImageUpload = ({ target: { files } }) => {
    if (!files.length || !files[0].type.includes('image')) {
      return;
    }

    const reader = new FileReader();
    reader.addEventListener('load', () => {
      const image = new Image();
      image.src = reader.result;

      image.onload = () => {
        if (image.width >= 200) {
          this.setState({ imageSrc: reader.result, cropping: true });
        } else {
          this.setState({
            rtvDialogContent: {
              open: true,
              content: {
                title: 'Uups',
                message:
                  'Tu foto es muy angosta! Subi una más ancha, de mínimo 200px'
              }
            }
          });
        }
      };
    });
    reader.readAsDataURL(files[0]);
  };

  render() {
    const { classes } = this.props;
    const GRADIENTS = {
      ROLE_SHOWROOM: ['#B0CAFB', '#AFE1BC'],
      ROLE_PREMIUM: ['#FAACA8', '#BE6DF7'],
      ROLE_CELEBRITY: ['#FAD2A5', '#EE6184'],
      ROLE_VIP: ['#B2C8FD', '#F3BDBD'],
      ROLE_REGULAR: ['#F4ABA7', '#FEF0AD'],
      DEFAULT: ['#F4ABA7', '#FEF0AD']
    };

    if (!this.state.user) {
      return (
        <div className={classes.loadingView}>
          <img src={LoadingGif} alt="loading" />
          <Typography color="primary">
            {i18next.t('loadingDresser', { ns: 'dresser' })}
          </Typography>
        </div>
      );
    }

    let editRight = false;
    if (this.props.loggedInUser) {
      if (this.props.loggedInUser.id === this.state.user.id) {
        editRight = true;
      }
    }

    let role = this.state.user.type;
    if (!role && Array.isArray(this.state.user.roles)) {
      role = this.state.user.roles.find(r => GRADIENTS[r]);
    }
    const gradient = GRADIENTS[role] || GRADIENTS.DEFAULT;
    const background = `linear-gradient(90deg, ${gradient[0]} 0%, ${gradient[1]} 100%)`;

    const vacationMode = this.state.user.roles.includes('ROLE_VACATION');

    return (
      <div className={classes.dresser}>
        <Helmet>
          <title>{`RTV - Vestidor de ${this.state.user.username}`}</title>
          <meta
            property="og:title"
            content={`El Vestidor de ${this.state.user.username}`}
          />
          <meta
            property="og:description"
            content="Conocé mi vestidor y seguime para enterarte las novedades!"
          />
          {this.state.user.media && (
            <meta
              property="og:image"
              content={`${
                this.state.user.media.default_small ||
                this.state.user.media.user_small
              }`}
            />
          )}
        </Helmet>
        <MailShareDialog
          open={this.state.mailDialog}
          mailString={this.state.mailString}
          setMailString={this.setMailString}
          onClose={this.handleMailDialogClose}
          onConfirm={this.confirmMailDialog}
        />
        <RTVMenu
          transition
          open={this.state.shareMenu}
          anchorEl={this.shareRef.current}
          onClose={() => this.setState({ shareMenu: false })}
        >
          <DresserShareMenu
            path={`/vestidor/${this.state.user.username}`}
            isOwner={
              this.props.isLoggedIn &&
              this.props.loggedInUser.id === this.state.user.id
            }
            openMailDialog={this.openMailDialog}
            type="Dresser"
          />
        </RTVMenu>

        <RTVMenu
          transition
          open={this.state.moreMenu}
          anchorEl={this.moreRef.current}
          onClose={() => this.setState({ moreMenu: false })}
        >
          <MoreOptions
            user={this.state.user}
            classes={classes}
            share={this.handleOpenShareMenu}
          />
        </RTVMenu>

        <div className={classes.dresserHeader} style={{ background }}>
          <div className={classes.dresserHeaderLeft}>
            <div className={classes.avatarSection}>
              <RTVAvatar
                style={{ width: '125px', height: '125px', marginRight: '8px' }}
                src={
                  this.state.user.media
                    ? this.state.user.media.default_big ||
                      this.state.user.media.user_big
                    : null
                }
              />
              {editRight && (
                <>
                  <RTVDialog
                    open={this.state.rtvDialogContent.open}
                    dialogProps={{
                      onExited: () =>
                        this.setState(state => ({
                          ...state,
                          rtvDialogContent: { open: false, content: {} }
                        }))
                    }}
                    onClose={() =>
                      this.setState(state => ({
                        ...state,
                        rtvDialogContent: {
                          ...state.rtvDialogContent,
                          open: false
                        }
                      }))
                    }
                    {...this.state.rtvDialogContent.content}
                  />
                  <input
                    accept="image/*"
                    type="file"
                    hidden
                    onChange={this.handleImageUpload}
                    id="avatar-input"
                  />
                  <label htmlFor="avatar-input">
                    <Typography className={classes.editAvatarText}>
                      <SvgIcon style={{ marginRight: '4px' }}>
                        <EditIcon />
                      </SvgIcon>
                      Cambiar foto
                    </Typography>
                  </label>
                </>
              )}
              {this.state.cropping && (
                <ImageEditorDialog
                  handleClose={() => this.setState({ cropping: false })}
                  handleEditorFinish={this.handleEditorFinish}
                  image={this.state.imageSrc}
                  loading={this.state.imageLoading}
                />
              )}
            </div>
            <div className={classes.userInfoHeader}>
              <div style={{ display: 'flex' }}>
                <Typography
                  style={{
                    fontWeight: 700,
                    fontSize: '1.3rem',
                    textTransform: 'uppercase'
                  }}
                >
                  {this.state.user.username}
                </Typography>
                <RoleIcon
                  style={{
                    marginLeft: '8px',
                    marginTop: '2px'
                  }}
                  user={this.state.user}
                />
              </div>
              <div className={classes.ratingSection}>
                <RTVRating
                  name="profile-rating"
                  value={this.state.user.average_review_stars}
                  readOnly
                />
                <Typography
                  className={classes.ratingText}
                  onClick={() => this.changePage(this.PAGES.ABOUT_ME)}
                >
                  Calificaciones
                  <ChevronRight style={{ marginLeft: '4px' }} />
                </Typography>
              </div>
              <Typography component="span">
                <Typography
                  component="span"
                  style={{ fontWeight: 800, marginRight: '8px' }}
                >
                  {this.state.userStats
                    ? `${abbreviateNumbers(this.state.userStats.total_sales)}`
                    : '-'}
                </Typography>
                VENTAS
              </Typography>
            </div>
          </div>
          <div className={classes.dresserHeaderRight}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => this.changePage(this.PAGES.ABOUT_ME)}
            >
              Sobre mí
            </Button>
            {!editRight && (
              <RTVFollowButton user={this.state.user.id}>
                {followProps => (
                  <Button
                    variant="contained"
                    color={followProps.following ? 'secondary' : 'primary'}
                    disabled={followProps.loading}
                    onClick={followProps.onClick}
                  >
                    {followProps.following ? 'Siguiendo' : 'Seguir'}
                  </Button>
                )}
              </RTVFollowButton>
            )}
            <Button
              className={classes.shareButton}
              variant="contained"
              color="primary"
              onClick={this.handleOpenShareMenu}
              ref={this.shareRef}
            >
              <SvgIcon color="inherit">
                <ShareIcon className={classes.shareIcon} />
              </SvgIcon>
            </Button>
            {/*
            Disabling this since it was decided to
            remove these three dots menu. But leaving it here
            in case we change this. TODO(Toti)

            <IconButton
              ref={this.moreRef}
              onClick={this.handleOpenMoreMenu}
            >
              <SvgIcon>
                <MoreIcon stroke="#fff" />
              </SvgIcon>
            </IconButton>
            */}
          </div>
        </div>
        {this.state.userStats && (
          <div className={classes.dresserNav}>
            <div
              role="presentation"
              onClick={() => this.changePage(this.PAGES.PRODUCTS)}
              className={`${classes.selector} ${
                this.state.currentPage === this.PAGES.PRODUCTS
                  ? classes.selected
                  : ''
              }`}
            >
              <Typography
                style={{ lineHeight: 1, fontWeight: 800, fontSize: '2rem' }}
              >
                {abbreviateNumbers(this.state.userStats.total_products)}
              </Typography>
              <Typography style={{ fontWeight: 500 }}>Productos</Typography>
            </div>

            <Divider orientation="vertical" />

            <div
              role="presentation"
              onClick={
                this.state.userStats.total_followers === 0
                  ? undefined
                  : () => this.changePage(this.PAGES.FOLLOWERS)
              }
              className={clsx(classes.selector, {
                [classes.selected]:
                  this.state.currentPage === this.PAGES.FOLLOWERS,
                [classes.notClickable]:
                  this.state.userStats.total_followers === 0
              })}
            >
              <Typography
                style={{ lineHeight: 1, fontWeight: 800, fontSize: '2rem' }}
              >
                <RTVFollowButton user={this.state.user.id}>
                  {followProps => (
                    <>
                      {followProps.justActed &&
                        followProps.following &&
                        abbreviateNumbers(
                          this.state.userStats.total_followers + 1
                        )}
                      {followProps.justActed &&
                        !followProps.following &&
                        abbreviateNumbers(
                          this.state.userStats.total_followers - 1
                        )}
                      {!followProps.justActed &&
                        abbreviateNumbers(this.state.userStats.total_followers)}
                    </>
                  )}
                </RTVFollowButton>
              </Typography>
              <Typography style={{ fontWeight: 500 }}>Seguidoras</Typography>
            </div>

            <Divider orientation="vertical" />

            <div
              role="presentation"
              onClick={
                this.state.userStats.following_total === 0
                  ? undefined
                  : () => this.changePage(this.PAGES.FOLLOWINGS)
              }
              className={clsx(classes.selector, {
                [classes.selected]:
                  this.state.currentPage === this.PAGES.FOLLOWINGS,
                [classes.notClickable]:
                  this.state.userStats.following_total === 0
              })}
            >
              <Typography
                style={{ lineHeight: 1, fontWeight: 800, fontSize: '2rem' }}
              >
                {abbreviateNumbers(this.state.user.following_total)}
              </Typography>
              <Typography style={{ fontWeight: 500 }}>Siguiendo</Typography>
            </div>

            <Divider orientation="vertical" />

            <div
              role="presentation"
              onClick={() => this.changePage(this.PAGES.FAVOURITES)}
              className={`${classes.selector} ${
                this.state.currentPage === this.PAGES.FAVOURITES
                  ? classes.selected
                  : ''
              }`}
            >
              <Typography
                style={{ lineHeight: 1, fontWeight: 800, fontSize: '2rem' }}
              >
                {abbreviateNumbers(
                  this.state.userStats.total_favourites ||
                    this.state.user.favourite_total
                )}
              </Typography>
              <Typography style={{ fontWeight: 500 }}>Favoritos</Typography>
            </div>
          </div>
        )}
        {this.state.currentPage === this.PAGES.PRODUCTS && (
          <>
            {this.state.user.promotion && (
              <div className={classes.promotionSection}>
                <div className={classes.promotionMessage}>
                  <RTVDialogButton
                    rtvDialogProps={{
                      title: 'Importante!',
                      message: i18next.t('promoInfo', { ns: 'dresser' })
                    }}
                  >
                    <SvgIcon className={classes.infoIcon}>
                      <InfoIcon />
                    </SvgIcon>
                  </RTVDialogButton>
                  <Typography color="primary" component="span">
                    <Typography style={{ fontWeight: 600 }}>
                      {translatePromotion(this.state.user.promotion.type)}{' '}
                      {i18next.t('inMyDresser', { ns: 'dresser' })}
                      <br />
                      <Typography>
                        Hasta el{' '}
                        <Moment
                          date={this.state.user.promotion.date_end}
                          format="DD/MM"
                          locale="es"
                        />{' '}
                        a las{' '}
                        <Moment
                          date={this.state.user.promotion.date_end}
                          format="LT"
                          locale="es"
                        />{' '}
                        aplicando el descuento en el carrito
                      </Typography>
                    </Typography>
                  </Typography>
                </div>
              </div>
            )}
            <Shop
              vacationMode={vacationMode}
              dresserView
              defaultFilter={{ user: [this.state.user.id] }}
            />
          </>
        )}
        {this.state.currentPage === this.PAGES.FAVOURITES && (
          <Favourites user={this.state.user.id} />
        )}
        {this.state.userStats &&
          this.state.currentPage === this.PAGES.FOLLOWERS && (
            <Followers user={this.state.user.id} />
          )}
        {this.state.userStats &&
          this.state.currentPage === this.PAGES.FOLLOWINGS && (
            <Followings user={this.state.user.id} />
          )}
        {this.state.userStats &&
          this.state.currentPage === this.PAGES.ABOUT_ME && (
            <AboutMe
              user={this.state.user}
              userStats={this.state.userStats}
              editRight={editRight}
            />
          )}
        {this.state.userStats &&
          this.state.currentPage === this.PAGES.ABOUT_ME &&
          editRight && (
            <div className={classes.actions}>
              <div className={classes.form}>
                <Typography style={{ color: '#707070' }}>
                  Modo vacaciones
                </Typography>
                <RTVHolidayMode
                  hasReservedProducts={this.state.hasReservedProducts}
                />
              </div>
              <div className={classes.form}>
                <Typography style={{ color: '#707070' }}>
                  {i18next.t('dresserDeactivate', { ns: 'dresser' })}
                </Typography>
                <RTVDisable />
              </div>
            </div>
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  publicStats: state.user.publicStats,
  privateStats: state.user.privateStats,
  users: state.user.users,
  userError: state.user.error,

  loggedInUser: state.auth.user,
  isLoggedIn: state.auth.isLoggedIn,

  userStatus: state.user.status,
  authStatus: state.auth.status
});

const mapDispatchToProps = dispatch => ({
  fetchUser: (user, idType) => dispatch(fetchUser(user, idType)),
  fetchPublicStats: user => dispatch(fetchPublicStats(user)),
  fetchPrivateStats: () => dispatch(fetchPrivateStats()),
  updateMedia: result => dispatch(updateMedia(result)),

  push: path => dispatch(push(path))
});

export default withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(withWidth()(Dresser)))
);
